__turbopack_context__.v({
  "pagination": "index-module-scss-module__D6mw-a__pagination",
});
